<template>

  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :filter-class="filterClass"
  >
    <template #create-button>
      <b-button
        v-if="canCreateUsual()"
        v-b-toggle.sidebar-create-letter
        variant="primary"
        @click="created"
      >
        {{ $t('Usual') }}
      </b-button>
      <b-button
        v-if="canCreateTargeted()"
        v-b-toggle.sidebar-create-letter
        variant="success"
        class="ml-1"
        @click="targeted"
      >
        {{ $t('Targeted') }}
      </b-button>
    </template>
    <template #create-body>
      <create
        ref="createLetter"
        @refetchData="refetchData"
      />
    </template>
    <template #cell(period)="{ data }">
      {{ data.value.name }}
    </template>

    <template #cell(to_org)="{ data }">
      {{ $langName(data.value.name) }}
    </template>

    <template #cell(letter_status)="{ data }">
      <b-badge :variant="getLetterStatusColor(data.value)">
        {{ $langName(getLetterStatus(data.value).name) }}
      </b-badge>
    </template>

    <template #cell(letter_type)="{ data }">
      {{ $langName(getLetterType(data.value).name) }}
    </template>

    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">
        <feather-icon
          v-b-toggle.sidebar-create-letter
          icon="EyeIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="$router.push({ name: 'letter-view', params: { id: data.item.id }})"
        />
        <feather-icon
          v-if="canUpdate(data.item)"
          v-b-toggle.sidebar-create-letter
          icon="EditIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="update(data.item)"
        />
        <feather-icon
          v-if="canDelete(data.item)"
          icon="TrashIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="remove(data.item)"
        />
        <feather-icon
          icon="ArchiveIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="history(data.item)"
        />
        <feather-icon
          v-if="canDraft(data.item)"
          :id="`can-change-to-draf-${data.item.id}`"
          icon="UnlockIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="changeToDraft(data.item)"
        />
        <b-tooltip
          :title="$t('Change to Draft')"
          :target="`can-change-to-draf-${data.item.id}`"
        />
      </div>
    </template>
  </l-table>
</template>

<script>
import {
  BButton, VBToggle, BBadge, BTooltip,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import letterModule from '@/store/letter/index'
import Create from './Create.vue'
import permission from './permission'
import LTable from '@/views/components/LTable.vue'
import Letter from '@/views/components/filters/service/Letter'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BTooltip,
    LTable,
    BButton,
    Create,
    BBadge,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    this.$store.dispatch('staticModule/letterTypes')
    this.$store.dispatch('staticModule/letterStatuses')
    this.$store.dispatch('staticModule/periodList')
    this.$store.dispatch('staticModule/organizationList')
  },
  methods: {
    getLetterType(id) {
      return this.$store.getters['staticModule/getLetterType'](id)
    },
    getLetterStatus(id) {
      return this.$store.getters['staticModule/getLetterStatus'](id)
    },
    getLetterStatusColor(id) {
      return this.$store.getters['staticModule/getLetterStatusColor'](id)
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
    },
    created() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`, this.$store.state.staticModule.letterTypeSimple)
      this.$refs.createLetter.loadPeriods()
    },
    targeted() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`, this.$store.state.staticModule.letterTypeTargeted)
      this.$refs.createLetter.loadPeriods()
    },
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, this.refetchData)
    },
    history(letter) {
      this.$router.push({
        name: 'letter-history',
        params: { id: letter.id },
      })
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
    changeToDraft(data) {
      this.$removeSwal(
        this,
        { id: data.id, body: { letter_status: this.$store.state.staticModule.letterStatusDraft } },
        `${this.MODULE_NAME}/patch`,
        this.refetchData,
        {
          text: '',
          confirmButtonText: 'Change To Draft',
          successTitle: 'Change To Draft',
          successText: 'Successfully completed',
          errorText: 'There was an error in successful execution',
        },
      )
    },
  },
  setup() {
    const MODULE_NAME = 'letter'
    const filterClass = new Letter()
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, letterModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      ...config(),
      MODULE_NAME,
      filterClass,
      ...permission(),
    }
  },
}
</script>
